
app.pageoffreController = app.pageoffreController || {};
app.pageoffreController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.slidersOptions();
        this.panelGaranties();
        this.annimImage();
        this.CalculCotisation();
    },

    slidersOptions : function () {
        var blkListe = $('.blk-options .liste_options');
        var blkSlider = $('.blk-options .slider-options');

        if (window.matchMedia("(max-width: 768px)").matches) {
            $('.remboursements', blkListe).slick({
                dots: false,
                infinite: true,
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                slide: '.blk-options .liste_options .option .remboursement',
            });

            $('.arrow-left', blkListe).on('click', function () {
                $(this).closest('.remboursements').slick('slickPrev');
            });

            $('.arrow-right', blkListe).on('click', function () {
                $(this).closest('.remboursements').slick('slickNext');
            });

            var options = $('.option', blkListe);

            $('.titre', options).on('click', function () {
                var option = $(this).parent();
                var text = option.find('.text');
                var content = text.find('.text-content');

                if (window.matchMedia("(max-width: 768px)").matches) {
                    options.removeClass('active');
                    $('.text', options).removeAttr('style');
                    $('.title', options).removeClass('active');
                    option.addClass('active');

                    text.height(content.outerHeight());
                }
            });

            $('.option.active .text', blkListe).height($('.option.active .text .text-content', blkListe).outerHeight());
        } else {

            blkSlider.slick({
                dots: false,
                infinite: false,
                adaptiveHeight: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                prevArrow: $('.arrow-left', blkSlider),
                nextArrow: $('.arrow-right', blkSlider),
                slide: '.option',
                touchMove: false,
                swipeToSlide: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1180,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
            });

            blkListe.slick({
                dots: false,
                infinite: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                slide: '.option',
                arrows: false,
                fade: true,
                speed: 500,
                touchMove: false,
                swipeToSlide: false,
                swipe: false
            });

            $('.option', blkSlider).on('click', function () {
                var numSlide = $(this).data('slick-index');

                blkSlider.slick('slickGoTo', numSlide);
                blkListe.slick('slickGoTo', numSlide);

                $('.option', blkSlider).removeClass('active');
                $(this).addClass('active');
            });
        }
    },

    panelGaranties : function () {
        /****** BLK GARANTIES ******/
        var blk = $('.blk-garanties');

        $('.btn-option', blk).on('click', function () {
            var btnOption = $(this);

            var garanties = $('.garanties', blk);

            var datas = btnOption.data();
            var title = btnOption.text();

            if (btnOption.hasClass('active-2')) {
                garanties.removeClass('multi-col');
                btnOption.removeClass('active-2');
                btnOption.removeClass('active');
            } else if (btnOption.hasClass('active-1') && $('.btn-option.active-2', blk)[0]) {
                var btn = $('.btn-option.active-2', blk);

                garanties.removeClass('multi-col');
                btnOption.removeClass('active');
                btnOption.removeClass('active-1');
                btn.removeClass('active-2');
                btn.addClass('active-1');

                datas = btn.data();
                title = btn.text();

                $('.title-options .col-left .text', blk).html(title);
                for(var i in datas) {
                    $('.data-' + i + ' .col-left .text').html(datas[i]);
                }
            } else if ($('.btn-option.active-1', blk)[0] && $('.btn-option.active-2', blk)[0] && !btnOption.hasClass('active')) {
                var btnActive2 = $('.btn-option.active-2', blk);
                btnActive2.removeClass('active-2');
                btnActive2.removeClass('active');

                btnOption.addClass('active');
                btnOption.addClass('active-2');

                $('.title-options .col-right .text', blk).html(title);
                for(var j in datas) {
                    $('.data-' + j + ' .col-right .text').html(datas[j]);
                }
            } else if (btnOption.hasClass('active-1')) {
                blk.removeClass('active');
                btnOption.removeClass('active');
                btnOption.removeClass('active-1');
                $('.garantie .content-garantie', garanties).removeAttr('style');
                $('.garantie.open', garanties).removeClass('open');
            } else {
                if (blk.hasClass('active')) {
                    garanties.addClass('multi-col');
                    btnOption.addClass('active');
                    btnOption.addClass('active-2');

                    $('.title-options .col-right .text', blk).html(title);
                    for(var k in datas) {
                        $('.data-' + k + ' .col-right .text').html(datas[k]);
                    }
                } else {
                    blk.addClass('active');
                    btnOption.addClass('active');
                    btnOption.addClass('active-1');
                    $('.garantie-0', garanties).addClass('open');

                    $('.title-options .col-left .text', blk).html(title);
                    for(var l in datas) {
                        $('.data-' + l + ' .col-left .text').html(datas[l]);
                    }
                }
            }

            setTimeout( function () {
                var garantieOpen = $('.garantie.open', garanties);
                $('.content-garantie', garantieOpen).height($('.content-garantie .content', garantieOpen).innerHeight());
            }, 250);
        });

        $('.title-garantie', blk).on('click', function () {
            if (blk.hasClass('active')) {
                var garantie = $(this).closest('.garantie');
                var garanties = $('.garantie', blk);

                if (garantie.hasClass('open')) {
                    $('.content-garantie', garantie).removeAttr('style');
                    garantie.removeClass('open');
                } else {
                    garanties.removeClass('open');
                    garantie.addClass('open');
                    $('.content-garantie', garanties).removeAttr('style');
                    $('.content-garantie', garantie).height($('.content-garantie .content', garantie).outerHeight());
                }
            }
        });

        $('.blk-options .blk-content .liste_options .option .garantie-link .btn, .blk-intro .blk-content .btn-garanties, .formulaire-resultat .btn-garanties').on('click', function (event) {
            event.preventDefault();

            var option = $(this).data('option');
            var page = $(this).attr('href'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            var top = Math.round($('#garanties').offset().top);

            $('html, body').animate({scrollTop: top}, speed); // Go

            if (option) {
                $('.blk-garanties .blk-content .menu-options .btn-option[data-option="' + option + '"]').click();
            }

            return false;
        });

        $('.blk-intro .blk-content .btn-calcul').on('click', function (event) {
            event.preventDefault();

            var speed = 750; // Durée de l'animation (en ms)
            var top = Math.round($('#calcul').offset().top);

            $('html, body').animate({scrollTop: top}, speed); // Go

            return false;
        });
    },

    annimImage : function () {
        var introHeight = $('.blk-illustration').position().top;

        $(window).scroll( function () {
            var scroll = $(window).scrollTop();

            if (scroll >= (introHeight - 300)) {
                $('.blk-illustration .img-2').attr('style', 'opacity: 1;');
            }
        });
    },

    CalculCotisation : function() {

        var isDateSupported = function() {
            var input = document.createElement('input');
            var notADateValue = 'not-a-date';

            input.setAttribute('type','date');
            input.setAttribute('value', notADateValue);

            return (input.value !== notADateValue);
        };

        if (isDateSupported()) {
            // Browser native date pickers are supported!
            $( "#jquery-datepicker-client" ).remove();
            $( "#jquery-datepicker-conjoint" ).remove();
        }

        if (!isDateSupported()) {
            $.datepicker.setDefaults({
                monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
                dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
                dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                weekHeader: 'Sem.',
                dateFormat: 'dd/mm/yy',
                // constrainInput: false
            } );

            $( "#jquery-datepicker-client" ).datepicker();
            $( "#jquery-datepicker-conjoint" ).datepicker();

            $("#native-datepicker-client").remove();
            $("#native-datepicker-conjoint").remove();
        }

        var formCalcul = $('.formulaire-calcul');
        var formResultat = $('.formulaire-resultat');

        var showResult = function() {
            formCalcul.fadeOut(200, 'linear', function() {
                formResultat.fadeIn( 200, 'linear');
                window.location.href = "#calcul";
            });
        };

        var showForm = function() {
            formResultat.fadeOut( 200, 'linear', function() {
                formCalcul.fadeIn( 200, 'linear');
                window.location.href = "#calcul";
            });
        };

        $("#bouton-calcul").click(function(e) {
            e.preventDefault();

            var checkboxClient = $("#checkbox-client");
            var checkboxConjoint = $("#checkbox-conjoint");
            var checkboxEnfant = $("#checkbox-enfant");
            var errorMessageEl = $(".error-message");

            var ageClient = 0;
            var ageConjoint = 0;
            var nombreEnfant = 0;

            var datepickerClient = $('.datepicker-client');
            var datepickerConjoint = $('.datepicker-conjoint');

            if (checkboxClient.is(":checked") && datepickerClient.val()) {
                var dateNaissanceClient = datepickerClient.val();
                var regexDateFormat = /^\d{2}\/\d{2}\/\d{4}$/;
                var regexYear4DigitMax = /^\d{4}-\d{2}-\d{2}$/;

                if(regexDateFormat.test(dateNaissanceClient)) {
                    dateNaissanceClient = dateNaissanceClient.split("/").reverse().join("-");
                }

                if(!regexYear4DigitMax.test(dateNaissanceClient)) {
                    errorMessageEl.text('Le format de date est incorrect. Veuillez vérifier et réessayer.');
                    errorMessageEl.show();
                    datepickerClient.addClass( "not-valid" );
                    return false;
                }

                ageClient = calculate_age(dateNaissanceClient) > 100 ? 100 : calculate_age(dateNaissanceClient);

                if(ageClient < 1) {
                    datepickerClient.addClass( "not-valid" );
                    errorMessageEl.text('Le format de date est incorrect. Veuillez vérifier et réessayer.');
                    errorMessageEl.show();
                    return false;
                }

                if (checkboxConjoint.is(":checked")) {
                    datepickerClient.removeClass( "not-valid" );
                    var dateNaissanceConjoint = datepickerConjoint.val();

                    if(regexDateFormat.test(dateNaissanceConjoint)) {
                        dateNaissanceConjoint = dateNaissanceConjoint.split("/").reverse().join("-");
                    }

                    if(!regexYear4DigitMax.test(dateNaissanceConjoint)) {
                        errorMessageEl.text('Le format de date est incorrect. Veuillez vérifier et réessayer.');
                        errorMessageEl.show();
                        datepickerConjoint.addClass( "not-valid" );
                        return false;
                    }

                    ageConjoint = calculate_age(dateNaissanceConjoint) > 100 ? 100 : calculate_age(dateNaissanceConjoint);

                    if(ageConjoint < 1) {
                        errorMessageEl.text('Le format de date est incorrect. Veuillez vérifier et réessayer.');
                        errorMessageEl.show();
                        datepickerConjoint.addClass( "not-valid" );
                        return false;
                    }
                }

                if (checkboxEnfant.is(":checked")) {
                    nombreEnfant = $('#nombre-enfant :selected').val();
                    nombreEnfant = parseInt(nombreEnfant,10);
                }

                showResult();
            } else {
                datepickerClient.addClass( "not-valid" );
                errorMessageEl.text('Veuillez renseigner votre date de naissance pour calculer vos mensualités.');
                errorMessageEl.show();
            }

            jQuery.ajax({
                type:"POST",
                // dataType: "json",
                url: my_ajax_object.ajax_url,
                data: {
                    'action': 'call_my_ajax_handler',
                    'ageClient': ageClient,
                    'ageConjoint': ageConjoint,
                    'nombreEnfant': nombreEnfant
                }
            }).done(function(response) {
                var data = $.parseJSON(response);

                var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };

                var dateNaissanceClientFormat = new Date(dateNaissanceClient);
                var resultatRecapitulatifHtml = '<p>Vous êtes né(e) le <strong>' + dateNaissanceClientFormat.toLocaleDateString('fr-FR', dateOptions) + '</strong>';

                if(dateNaissanceConjoint) {
                    var dateNaissanceConjointFormat = new Date(dateNaissanceConjoint);
                    resultatRecapitulatifHtml += ', votre conjoint est né(e) le <strong>' + dateNaissanceConjointFormat.toLocaleDateString('fr-FR', dateOptions) + '</strong>';
                }

                if(nombreEnfant > 0) {
                    var enfant = '';
                    if(nombreEnfant == 1) {
                        enfant = 'enfant';
                    } else {
                        enfant = 'enfants';
                    }

                    if(nombreEnfant <= 2) {
                        resultatRecapitulatifHtml += ' et vous souhaitez associer <strong>' + nombreEnfant + ' ' + enfant +'</strong> à votre contrat' ;
                    } else {
                        resultatRecapitulatifHtml += ' et vous souhaitez associer au moins <strong>3 enfants</strong> à votre contrat' ;
                    }
                }

                resultatRecapitulatifHtml += '</p>';

                $('.resultat-recapitulatif').html(resultatRecapitulatifHtml);

                var tarifClientEssentielle = parseFloat(data[0][0].tarif_essentielle);
                var tarifClientEquilibre = parseFloat(data[0][0].tarif_equilibre);
                var tarifClientSuperieure = parseFloat(data[0][0].tarif_superieure);
                var tarifClientArgent = parseFloat(data[0][0].tarif_argent);
                //var tarifClientOr = parseFloat(data[0][0].tarif_or);

                var tarifConjointEssentielle = 0;
                var tarifConjointEquilibre = 0;
                var tarifConjointSuperieure = 0;
                var tarifConjointArgent = 0;
                //var tarifConjointOr = 0;

                var tarifEnfantEssentielle = 0;
                var tarifEnfantEquilibre = 0;
                var tarifEnfantSuperieure = 0;
                var tarifEnfantArgent = 0;
                //var tarifEnfantOr = 0;

                var multiplicateur = 0;
                var enfantTexte = '';

                var totalEssentielle = tarifClientEssentielle;
                var totalEquilibre = tarifClientEquilibre;
                var totalSuperieure = tarifClientSuperieure;
                var totalArgent = tarifClientArgent;
                //var totalOr = tarifClientOr;

                var essentielleHtml = '<span class="tarif-client">Vous = ' + tarifClientEssentielle + '&euro;</span>';
                var equilibreHtml = '<span class="tarif-client">Vous = ' + tarifClientEquilibre + '&euro;</span>';
                var superieureHtml = '<span class="tarif-client">Vous = ' + tarifClientSuperieure + '&euro;</span>';
                var argentHtml = '<span class="tarif-client">Vous = ' + tarifClientArgent + '&euro;</span>';
                //var orHtml = '<span class="tarif-client">Vous = ' + tarifClientOr + '&euro;</span>';

                if(typeof data[1] !== 'undefined') {

                    if(data[1][0].personne === 'conjoint') {
                        tarifConjointEssentielle = parseFloat(data[1][0].tarif_essentielle);
                        tarifConjointEquilibre = parseFloat(data[1][0].tarif_equilibre);
                        tarifConjointSuperieure = parseFloat(data[1][0].tarif_superieure);
                        tarifConjointArgent = parseFloat(data[1][0].tarif_argent);
                        //tarifConjointOr = parseFloat(data[1][0].tarif_or);

                        totalEssentielle += tarifConjointEssentielle;
                        totalEquilibre += tarifConjointEquilibre;
                        totalSuperieure += tarifConjointSuperieure;
                        totalArgent += tarifConjointArgent;
                        //totalOr += tarifConjointOr;

                        essentielleHtml += '<span class="tarif-conjoint">Votre conjoint = ' + tarifConjointEssentielle + '&euro;</span>';
                        equilibreHtml += '<span class="tarif-conjoint">Votre conjoint = ' + tarifConjointEquilibre + '&euro;</span>';
                        superieureHtml += '<span class="tarif-conjoint">Votre conjoint = ' + tarifConjointSuperieure + '&euro;</span>';
                        argentHtml += '<span class="tarif-conjoint">Votre conjoint = ' + tarifConjointArgent + '&euro;</span>';
                        //orHtml += '<span class="tarif-conjoint">Votre conjoint = ' + tarifConjointOr + '&euro;</span>';

                    } else {

                        if(nombreEnfant == 1) {
                            enfantTexte = 'Votre enfant';
                        } else {
                            enfantTexte = 'Vos enfants';
                        }

                        if(nombreEnfant <= 2) {
                            multiplicateur = nombreEnfant;
                        } else {
                            multiplicateur = 2;
                        }

                        //Pas de conjoint ajouté donc les data correspondent a enfant
                        tarifEnfantEssentielle = parseFloat(data[1][0].tarif_essentielle) * multiplicateur;
                        tarifEnfantEquilibre = parseFloat(data[1][0].tarif_equilibre) * multiplicateur;
                        tarifEnfantSuperieure = parseFloat(data[1][0].tarif_superieure) * multiplicateur;
                        tarifEnfantArgent = parseFloat(data[1][0].tarif_argent) * multiplicateur;
                        //tarifEnfantOr = parseFloat(data[1][0].tarif_or) * multiplicateur;

                        totalEssentielle += tarifEnfantEssentielle;
                        totalEquilibre += tarifEnfantEquilibre;
                        totalSuperieure += tarifEnfantSuperieure;
                        totalArgent += tarifEnfantArgent;
                        //totalOr += tarifEnfantOr;

                        essentielleHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantEssentielle + '&euro;</span>';
                        equilibreHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantEquilibre + '&euro;</span>';
                        superieureHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantSuperieure + '&euro;</span>';
                        argentHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantArgent + '&euro;</span>';
                        //orHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantOr + '&euro;</span>';

                    }
                }

                if(typeof data[2] !== 'undefined') {
                    if(nombreEnfant == 1) {
                        enfantTexte = 'Votre enfant';
                    } else {
                        enfantTexte = 'Vos enfants';
                    }
                    if(nombreEnfant <= 2) {
                        multiplicateur = nombreEnfant;
                    } else {
                        multiplicateur = 2;
                    }

                    //Pas de conjoint ajouté donc les data correspondent a enfant
                    tarifEnfantEssentielle = parseFloat(data[2][0].tarif_essentielle) * multiplicateur;
                    tarifEnfantEquilibre = parseFloat(data[2][0].tarif_equilibre) * multiplicateur;
                    tarifEnfantSuperieure = parseFloat(data[2][0].tarif_superieure) * multiplicateur;
                    tarifEnfantArgent = parseFloat(data[2][0].tarif_argent) * multiplicateur;
                    //tarifEnfantOr = parseFloat(data[2][0].tarif_or) * multiplicateur;

                    totalEssentielle += tarifEnfantEssentielle;
                    totalEquilibre += tarifEnfantEquilibre;
                    totalSuperieure += tarifEnfantSuperieure;
                    totalArgent += tarifEnfantArgent;
                    //totalOr += tarifEnfantOr;

                    essentielleHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantEssentielle + '&euro;</span>';
                    equilibreHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantEquilibre + '&euro;</span>';
                    superieureHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantSuperieure + '&euro;</span>';
                    argentHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantArgent + '&euro;</span>';
                    //orHtml += '<span class="tarif-enfant">' + enfantTexte + '** = ' + tarifEnfantOr + '&euro;</span>';
                }

                var losangeEssentielle = $('.losange-essentielle');
                var losangeEquilibre = $('.losange-equilibre');
                var losangeSuperieure = $('.losange-superieure');
                var losangeArgent = $('.losange-argent');
                //var losangeOr = $('.losange-or');

                losangeEssentielle.find('.total-price>span:first-child').html(totalEssentielle.toFixed(2) + '&euro;*');
                losangeEquilibre.find('.total-price>span:first-child').html(totalEquilibre.toFixed(2) + '&euro;*');
                losangeSuperieure.find('.total-price>span:first-child').html(totalSuperieure.toFixed(2) + '&euro;*');
                losangeArgent.find('.total-price>span:first-child').html(totalArgent.toFixed(2) + '&euro;*');
                //losangeOr.find('.total-price>span:first-child').html(totalOr.toFixed(2) + '&euro;*');

                losangeEssentielle.find('.detail-price').html(essentielleHtml);
                losangeEquilibre.find('.detail-price').html(equilibreHtml);
                losangeSuperieure.find('.detail-price').html(superieureHtml);
                losangeArgent.find('.detail-price').html(argentHtml);
                //losangeOr.find('.detail-price').html(orHtml);
            });
        });

        $("#bouton-nouveau-calcul").click(function() {
            showForm();
            $('input[type=\'date\']').val('');
            $('.datepicker-client').removeClass('not-valid');
            $('.datepicker-conjoint').removeClass('not-valid');
            $('.error-message').hide();
        });

        var checkboxConjoint =  $('#checkbox-conjoint');
        var checkboxEnfant = $('#checkbox-enfant');

        checkboxConjoint.on('change', function() {
            $(this).parents('.form-conjoint').toggleClass('not-checked');

            if($(this).parents('.form-conjoint').hasClass('not-checked')) {
                $('#jquery-datepicker-conjoint').attr("disabled", true);
                $('#native-datepicker-conjoint').attr("disabled", true);
                $('#native-datepicker-conjoint').val('');
            } else {
                $('#jquery-datepicker-conjoint').attr("disabled", false);
                $('#native-datepicker-conjoint').attr("disabled", false);
            }
        });

        checkboxEnfant.on('change', function() {
            $(this).parents('.form-enfant').toggleClass('not-checked');

            if($(this).parents('.form-enfant').hasClass('not-checked')) {
                $('#nombre-enfant').attr("disabled", true);
            } else {
                $('#nombre-enfant').attr("disabled", false);
            }
        });

        function calculate_age(dob) {
            var birthday = new Date(dob);
            var currentYear = new Date();
            var diff = currentYear.getFullYear() - birthday.getFullYear();

            return Math.abs(diff);
        }
    }

};

$(document).ready(function(){
    if($(".page-offre-js").length) {
        app.pageoffreController.defaultAction.init();
    }
});
